// src/App.js
import { auth } from './firebaseConfig';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import Assessments from './pages/Assessments';
import AssessmentAnswers from './pages/AssessmentAnswers';
import ForgotPassword from './pages/ForgotPassword'; 
import Fractals from './pages/Fractals';
import Login from './pages/Login';
import { onAuthStateChanged } from 'firebase/auth';
import Sidebar from './components/Sidebar';
import Workspaces from './pages/Workspaces';
import SelectWorkspace from './components/SelectWorkspace'; 
import { WorkspaceProvider } from './context/WorkspaceContext';

import './App.css';

function App( { apiToken } ) {
  const [user, setUser] = useState({ username: 'guest'});
  const [loading, setLoading] = useState(true);  // Estado de carga inicial

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user ? user : null);
      setLoading(false);  // Terminamos la carga cuando Firebase responde
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div className="loading-screen">Cargando...</div>;  // Mostrar pantalla de carga
  }

  const AssessmentAnswersWrapper = () => {
    const { id } = useParams();
    return <AssessmentAnswers invitationCode={id} />;
  };

  return (
    <Router>
      <Routes>
        <Route path="/invitation/assessment/:id" element={<AssessmentAnswersWrapper />} />
        <Route
          path="*"
          element={
            <WorkspaceProvider> {/* Envolver la aplicación con WorkspaceProvider */}
              <div className={`App ${user ? 'app-with-sidebar' : ''}`}>
                {user && <Sidebar />}
                <div className="main-content">
                  {user && <SelectWorkspace />}
                  <Routes>
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    {!user ? (
                      <>
                        <Route path="*" element={<Login />} />
                      </>
                    ) : (
                      <>
                        <Route path="/assessments" element={<Assessments apiToken={apiToken} />} />
                        <Route path="/fractals" element={<Fractals apiToken={apiToken} />} />
                        <Route path="/workspaces" element={<Workspaces apiToken={apiToken} />} />
                        <Route path="*" element={<Navigate to="/workspaces" />} />
                      </>
                    )}
                  </Routes>
                </div>
              </div>
            </WorkspaceProvider>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
